

































































































































































































































import { Vue, Component, Watch} from 'vue-property-decorator'
import { Route } from 'vue-router'
import { getModule } from 'vuex-module-decorators'
import { Meta } from './store/meta'

@Component
export default class App extends Vue {
  private currentRouteIsPublic = false

  get production() {
    return process.env.NODE_ENV == "production"
  }

  get meta() {
    return getModule(Meta)
  }

  get isLoading() {
    return this.meta.loading
  }

  get isLogin() {
    return this.meta.login
  }

  get showSideBar() {
    return this.isLogin && 
      !this.currentRouteIsPublic
  }

  get isBusiness() {
    return this.meta.plan !== "free"
  }

  get isOwner() {
    return this.meta.isOwner
  }

  get isViewer() {
    return this.meta.isViewer
  }

  get businessDisabledLabel() {
    if (this.isViewer) return "閲覧専用ロールではご利用いただけません。"
    return "企業ユーザのみご利用いただける機能です。"
  }

  get ownerOnlyLabel() {
    if (!this.isBusiness) return "企業ユーザのみご利用いただける機能です。"
    if (!this.isOwner) return "owner ロールのみご利用いただけます。"
    return ""
  }

  @Watch("$route", { immediate: true, deep: true })
  onRouteChanged(newVal: Route) {
    this.currentRouteIsPublic = newVal.meta?.public == true
    if (newVal.meta?.title) {
      document.title = `${newVal.meta.title} | BOCCO emo Platform API`
    }
  }


  logOut() {
    this.meta.updateAccessToken("")
    this.meta.updateRefreshToken("")

    this.$router.replace("/login")
  }
}
